export default __webpack_public_path__ + "static/media/blue_calendar.f7a1d9d1.svg";